
import axios from 'axios'
// import { Notification, MessageBox, Message, Loading } from "element-ui";
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, 
  timeout: 5000 
})
axios.defaults.headers["Content-Type"] = "application/json;charset=utf-8";

console.log(process.env.VUE_APP_BASE_API,'process.env.VUE_APP_BASE_API')

service.interceptors.request.use(
  config => {
    console.log(config,'config')
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)
 
// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)
export default service;